import {Fragment} from "react";
import {PlanFeatureProvider} from '~/pages/context/PlanFeatureContext';
import 'react-toastify/dist/ReactToastify.css';
function AIChatbotChatLayout({children })  {
    return (
        <PlanFeatureProvider>
            <main className='main'>
                {children}
            </main>
        </PlanFeatureProvider>
    )
}
export default AIChatbotChatLayout;